import React from 'react';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import { useQuery } from 'react-query';
import OrganizationService, { OrganizationProps } from 'services/hooks/organization-service';
import { Table } from '../Common/Table';
import Save from './OrgForms/save';
import Delete from './OrgForms/delete';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import { FilterSelect } from 'utils/FilterSelectUtils';

export default function OrgSaveMode() {
  const [getOrgsResult, setGetOrgsResult] = React.useState<OrganizationProps[] | null>([]);
  const {
    isLoading: isLoadingOrgs,
    refetch,
    data: orgData
  } = useQuery<OrganizationProps[], Error>('organizations', OrganizationService.findAllOrgs, {
    onError: (err: any) => {
      console.log(err.response?.data || err);
    }
  });

  React.useEffect(() => {
    if (orgData && Array.isArray(orgData)) {
      refetch();
      setGetOrgsResult(orgData);
    }
  }, [orgData, refetch]);

  const columns = React.useMemo(
    () => [
      {
        id: 'name',
        Header: 'Name',
        accessor: 'name',
        Filter: FilterSelect
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessor: (data: any) => data,
        Cell: (row: any) => {
          return (
            <div className="flex gap-4">
              <SecondaryButton
                onClick={() => {
                  row.setEditUUID(row.value.uuid);
                  row.setUpdateShowModal(true);
                }}
                buttonLabel="Edit"
                variant="default"
                size="px-4 w-auto"
              />
              <SecondaryButton
                onClick={() => {
                  row.setDeleteUUID(row.value.uuid);
                  row.setDeleteShowModal(true);
                }}
                buttonLabel="Delete"
                variant="default"
                size="px-4 w-auto"
              />
            </div>
          );
        },
        width: 150,
        disableFilters: true
      }
    ],
    []
  );

  if (isLoadingOrgs || !getOrgsResult) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return !isLoadingOrgs && getOrgsResult ? (
    <div className="organization">
      <Table
        name="Organizations"
        refetch={refetch}
        columns={columns}
        data={getOrgsResult}
        CreateForm={Save}
        DeleteForm={Delete}
        createQuery={OrganizationService.createOrg}
        updateQuery={OrganizationService.updateOrg}
        deleteQuery={OrganizationService.deleteOrgById}
        editQuery={OrganizationService.findOrgById}
        queryName="organizations"
        buttonName="Organization"
        toolTipMessage="Create and manage organizations. Multiple organizations can belong to the same building."
      />
    </div>
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
